import { getReviewTypeConfig } from "@/lib/mockData";

export interface ExperienceRow {
  experience_key: string;
  organization: string;
  major: string;
  type: string;
  location: string;
  review_count: number;
  avg_rating: number | string | null;
  has_review: boolean;
  has_compensation: boolean;
  has_interview: boolean;
  has_responsibilities: boolean;
  has_tips: boolean;
  has_recommendation: boolean;
  has_preceptor: boolean;
}

/** The categories that make an experience "100% documented". */
export const EXPERIENCE_CATEGORIES: Array<{ key: keyof ExperienceRow; label: string }> = [
  { key: "has_review", label: "Written review" },
  { key: "has_compensation", label: "Compensation" },
  { key: "has_interview", label: "Interview info" },
  { key: "has_responsibilities", label: "Responsibilities" },
  { key: "has_preceptor", label: "Preceptor info" },
];

/** Compensation is not collected for clinical rotations; preceptors only apply to clinical types. */
export const getExperienceCategories = (type?: string | null) => {
  const cfg = getReviewTypeConfig(type);
  return EXPERIENCE_CATEGORIES.filter(
    (c) =>
      (c.key !== "has_compensation" || cfg.showCompensation) &&
      (c.key !== "has_preceptor" || cfg.hasPreceptors)
  );
};

/** Normalizes the free-text major so wording variants map to the same experience. */
export const normalizeMajorKey = (major?: string | null) =>
  Array.from(
    new Set(
      (major || "")
        .split("•")
        .map((p) => p.trim().toLowerCase())
        .filter(Boolean)
    )
  )
    .sort()
    .join("|");

export const getExperienceKey = (organization: string, major?: string | null) =>
  `${(organization || "").trim().toLowerCase()}|${normalizeMajorKey(major)}`;

export const getCompletion = (row: ExperienceRow | null, type?: string | null) => {
  const categories = getExperienceCategories(type);
  if (!row) return { pct: 0, present: [] as string[], missing: categories.map((c) => c.label) };
  const present: string[] = [];
  const missing: string[] = [];
  for (const c of categories) {
    (row[c.key] ? present : missing).push(c.label);
  }
  return {
    pct: Math.round((present.length / categories.length) * 100),
    present,
    missing,
  };
};

